import { combineReducers } from '@reduxjs/toolkit';
import { loaderSlice } from './loaderSlice';

export const loaderReducer = combineReducers({
  loader: loaderSlice.reducer,
});
